"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const resume_json_1 = __importDefault(require("./resume.json"));
const frontend = [
    "TypeScript",
    "React.js",
    "Next.js",
    "TailwindCSS",
    "Styled Components",
    "SCSS",
    "Webpack",
    "Contentful",
];
const backend = [
    "TypeScript",
    "Node.js",
    "NestJS",
    "GraphQL",
    "Postgres",
    "Kafka",
    "Redis",
    "tRPC",
];
const monitoring = ["Grafana", "LogRocket", "Rollbar", "Sentry"];
const testing = [
    "TDD & BDD",
    "Characterization tests",
    "Jest",
    "Vitest",
    "Cypress",
    "React Testing Library",
];
const cloudInfra = [
    "Lambda",
    "AppRunner",
    "Fargate",
    "DynamoDB",
    "Aurora Postgres",
    "S3",
    "SQS",
    "SNS",
    "CloudWatch",
    "Terraform",
    "Docker",
    "GitHub Actions",
    "CI/CD Pipelines",
    "Azure OpenAI",
    "CosmosDB",
];
const usedBefore = [
    "Ruby on Rails",
    "Java",
    "Kotlin",
    "Python",
    "Svelte",
    "Marko.js",
    "jQuery",
    "Vanilla JavaScript",
    "Kubernetes",
    "Mocha / Chai / Sinon",
    "Capybara",
    "WebRTC",
];
const skillGroups = [
    { label: "Frontend", skills: frontend },
    { label: "Backend", skills: backend },
    { label: "Observability", skills: monitoring },
    { label: "Testing", skills: testing },
    {
        label: "Cloud & Infrastructure",
        skills: cloudInfra,
    },
];
const SimplifiedResume = () => (react_1.default.createElement("div", { className: "flex max-lg:flex-wrap" },
    react_1.default.createElement("div", { className: "w-1/4 pr-5 border-r border-[rgb(79,79,79)] max-lg:w-full max-lg:border-none max-lg:pr-0" },
        react_1.default.createElement("h3", { className: "text-[2.2rem] max-lg:text-[1.2rem] font-bold my-[15px]" }, "Tech Stack_"),
        react_1.default.createElement("div", { className: "text-[13px]" },
            react_1.default.createElement("h4", { className: "text-[15px] my-5 uppercase" }, "Main Stack"),
            skillGroups.map(({ label, skills }) => (react_1.default.createElement("div", { key: label, className: "mb-5" },
                react_1.default.createElement("h5", { className: "text-[11px] uppercase tracking-widest text-[rgb(120,120,120)] mb-2" }, label),
                react_1.default.createElement("div", { className: "flex flex-wrap gap-2" }, skills.map((skill) => (react_1.default.createElement("span", { key: skill, className: "text-[11px] uppercase tracking-wide border border-[rgb(79,79,79)] px-2 py-1" }, skill)))))))),
        react_1.default.createElement("div", { className: "text-[13px] mt-6" },
            react_1.default.createElement("h4", { className: "text-[15px] my-5 uppercase" }, "Used in the past"),
            react_1.default.createElement("div", { className: "flex flex-wrap gap-2" }, usedBefore.map((skill) => (react_1.default.createElement("span", { key: skill, className: "text-[11px] uppercase tracking-wide border border-[rgb(79,79,79)] px-2 py-1" }, skill)))))),
    react_1.default.createElement("div", { className: "w-3/4 ml-5 max-lg:w-full max-lg:mt-10 max-lg:ml-0" },
        react_1.default.createElement("h3", { className: "text-[2.2rem] max-lg:text-[1.2rem] font-bold my-[15px]" }, "Work Experience_"),
        resume_json_1.default.map((d) => (react_1.default.createElement("div", { key: d.company, className: "mb-8" },
            react_1.default.createElement("h4", { className: "text-[15px] my-5 uppercase" },
                react_1.default.createElement("b", null, d.role),
                " at ",
                react_1.default.createElement("b", null, d.company)),
            react_1.default.createElement("div", { className: "text-[13px] text-[rgb(120,120,120)] font-extrabold uppercase -mt-[15px] mb-[10px]" }, d.timeperiod),
            react_1.default.createElement("p", { className: "text-[13px] leading-relaxed" }, d.summary)))))));
exports.default = SimplifiedResume;
